<?xml version="1.0" encoding="utf-8"?>
<svg
  viewBox="0 0 512 512"
  xmlns="http://www.w3.org/2000/svg"
  xmlns:xlink="http://www.w3.org/1999/xlink"
>
  <path
    fill="#76DFFF"
    d="M151.4 310.1h.8c6.1 0 11 4.9 11 11v29.8c0 52.2 42.4 94.6 94.6 94.6c34.5 0 66.3-18.8 82.9-49.1c.7-1.3 1.7-2.4 2.8-3.3c-31.3-19.5-52.2-54.2-52.2-93.7c0-6.1 4.9-11 11-11s11 4.9 11 11c0 48.7 39.6 88.3 88.3 88.3c48.7 0 88.3-39.6 88.3-88.3s-39.6-88.3-88.3-88.3c-1.4 0-2.8-.3-4-.8c-7.7 23.8-22.5 45-42.9 60.9c-2 1.6-4.4 2.3-6.8 2.3c-3.3 0-6.5-1.5-8.7-4.2c-3.7-4.8-2.9-11.7 1.9-15.5c17-13.2 29.2-30.8 35.6-50.6c-.1 0-.2 0-.3.1c1.8-5.2 3.1-10.5 4.1-15.9c.9-5.5 1.3-11.1 1.3-16.7c0-58.2-47.3-105.5-105.5-105.5s-105.5 47.3-105.5 105.5V187c0 6.1-4.9 11-11 11c-.4 0-.8 0-1.2-.1c-.6.1-1.1.1-1.7.1H51.5v112h99.9z"
  >
  </path>
  <path
    fill="#59CAFC"
    d="M151.4 267.5H11c-6.1 0-11-4.9-11-11s4.9-11 11-11h140.4c6.1 0 11 4.9 11 11s-4.9 11-11 11z"
  >
  </path>
  <path
    fill="#59CAFC"
    d="M402.5 189.2c.9-6 1.3-12.2 1.3-18.4c0-70.3-57.2-127.5-127.5-127.5s-127.5 57.2-127.5 127.5v5.3H16.5c-6.1 0-11 4.9-11 11s4.9 11 11 11h140.4c.6 0 1.2-.1 1.7-.1c.4 0 .8.1 1.2.1c6.1 0 11-4.9 11-11v-16.2c0-58.2 47.3-105.5 105.5-105.5s105.5 47.3 105.5 105.5c0 32.7-14.8 63-40.6 83.2c-4.8 3.7-5.7 10.7-1.9 15.5c2.2 2.8 5.4 4.2 8.7 4.2c2.4 0 4.8-.8 6.8-2.3c20.4-15.9 35.1-37.1 42.9-60.9c1.3.5 2.6.8 4 .8c48.7 0 88.3 39.6 88.3 88.3S450.4 388 401.7 388c-48.7 0-88.3-39.6-88.3-88.3c0-6.1-4.9-11-11-11s-11 4.9-11 11c0 39.5 20.9 74.2 52.2 93.7c-1.1.9-2.1 2-2.8 3.3c-16.7 30.3-48.4 49.1-82.9 49.1c-52.2 0-94.6-42.4-94.6-94.6v-29.8c0-6.1-4.9-11-11-11H11c-6.1 0-11 4.9-11 11s4.9 11 11 11h130.1v18.8c0 64.3 52.3 116.6 116.6 116.6c42.5 0 81.7-23.2 102.2-60.5c.9-1.6 1.3-3.3 1.4-4.9c12.5 4.9 26.1 7.6 40.3 7.6c60.8 0 110.3-49.5 110.3-110.3c0-60.7-49-110-109.4-110.5z"
  >
  </path>
</svg>
